const getUrlParameter = (sParam: string): string | null => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get(sParam);
};

const getUrlParameterJson = (): string => {
  var search = window.location.search.substring(1);
  if (search !== '') {
    var urlParams = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
      return key === '' ? value : decodeURIComponent(value);
    });
    if (!getUrlParameter('shop')) {
      urlParams.shop = urlParams.store;
    }
    delete urlParams.store;
    return JSON.stringify(urlParams);
  }
  return '';
};

interface ConfigType {
  shop: string;
  embedded: string | null;
  hmac: string | null;
  host: string | null;
  source: string | null;
  token: string | null;
  locale: string | null;
  session: string | null;
  timestamp: string | null;
  role: string | null;
  instance: string | null;
  metaSiteId?: string | null;
  urlParams: string | null;
}

export const config: ConfigType = {
  shop: getUrlParameter('instanceId') || '',
  embedded: getUrlParameter('embedded'),
  hmac: getUrlParameter('hmac'),
  host: getUrlParameter('host'),
  source: getUrlParameter('source'),
  token: getUrlParameter('token'),
  locale: getUrlParameter('locale'),
  session: getUrlParameter('session'),
  timestamp: getUrlParameter('timestamp'),
  role: getUrlParameter('role'),
  instance: getUrlParameter('instance'),
  urlParams: getUrlParameterJson(),
  metaSiteId: null,
};
